module.exports = __webpack_public_path__ + "static/img/task_image.a28bd9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/task_image.jpg
// module id = ya10
// module chunks = 4